import { StyleSheet } from 'react-native';
import { tokens } from '@airtel/air-design-system';
export var getQuickSelectionWidgetStyles = isLargeScreen => {
  return StyleSheet.create({
    container: Object.assign({
      padding: tokens.spacing.SPACING_16,
      borderRadius: tokens.borderRadius.BORDER_RADIUS_16
    }, isLargeScreen && {
      padding: tokens.spacing.SPACING_20
    }),
    header: {
      marginBottom: tokens.spacing.SPACING_12
    }
  });
};